export default [
  { id: "bitcoin", name: "Bitcoin", rate: 1200 },
  { id: "litecoin", name: "Litecoin", rate: 50 },
  { id: "etherum", name: "Ethereum", rate: 300 },
  { id: "ripple", name: "XRP", rate: 1 },
  { id: "dogecoin", name: "Dogecoin", rate: 1 },
  { id: "monero", name: "Monero", rate: 50 }
];
